package com.bikompanion.ui.composables

import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.bikompanion.ui.preview.PreviewSurface
import com.bikompanion.ui.strings.LocalStrings

/** A parking spot's capacity: a full bar with a single legend entry, since there is no live split. */
@Composable
internal fun ParkingAvailabilityBar(
    capacity: Int,
    modifier: Modifier = Modifier,
) {
    AvailabilityBar(
        segments = listOf(AvailabilitySegment(LocalStrings.current.fieldCapacity, capacity, ParkingSpotColor)),
        total = capacity,
        modifier = modifier,
    )
}

@Preview
@Composable
private fun ParkingAvailabilityBarPreview() {
    PreviewSurface {
        ParkingAvailabilityBar(capacity = 12, modifier = Modifier.padding(16.dp))
    }
}
